import TextInput from 'componets/text-input/text-input';

export default TextInput;
